import { render, staticRenderFns } from "./SideNavLayout.vue?vue&type=template&id=254f6f9d&scoped=true"
import script from "./SideNavLayout.vue?vue&type=script&lang=js"
export * from "./SideNavLayout.vue?vue&type=script&lang=js"
import style0 from "./SideNavLayout.vue?vue&type=style&index=0&id=254f6f9d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254f6f9d",
  null
  
)

export default component.exports